import register from '@kpsys/angularjs-register';
import testRoutes from './test-page.routes';
import coreModule from 'core/core.module';

export default register('portaro.svelte-playground', [coreModule])
    .config(testRoutes)
    .name()